import { env } from '../config/env'
import { createRevenueCatPort, type BillingPort } from './port'

/**
 * The port for this build, or null. `env.revenueCatWebKey` THROWS while the
 * credential is unconfigured (`pending()`), so the read is caught: an absent
 * key means locked gates, never a blank page.
 */
export function billingPortFromEnv(): BillingPort | null {
  try {
    return createRevenueCatPort(env.revenueCatWebKey)
  } catch {
    return null
  }
}
